export default __webpack_public_path__ + "static/media/yamac-parasutu-paragliding.482bc3a7.jpg";